module.exports = __webpack_public_path__ + "static/cleric-of-lathander-4a8f2e2509b8926f2554307e1dfa7c7c.png";